import { PlatformLogo } from "@/components/PlatformLogo";
import { Button } from "atoms/button/Button";
import { TextButton } from "atoms/text-button/TextButton";
import { PersonalisationHeading } from "modules/personalisation/components/PersonalisationHeading";
import { PersonalisationScreenLayout } from "modules/personalisation/components/PersonalisationScreenLayout";

interface PersonalisationIntroProps {
  platformLogoUrl?: string;
  onBegin?: () => void;
  onSkip?: () => void;
}

export const PersonalisationIntro = ({
  platformLogoUrl,
  onBegin,
  onSkip,
}: PersonalisationIntroProps) => {
  return (
    <PersonalisationScreenLayout
      footer={
        <>
          <Button style="primary" size="large" fullWidth onClick={onBegin}>
            Begin
          </Button>
          <TextButton variant="secondary" onClick={onSkip}>
            Skip for now
          </TextButton>
        </>
      }
      contentClassName="pt-20"
    >
      <PlatformLogo
        logoUrl={platformLogoUrl}
        className="mb-[20%] self-center"
      />

      <PersonalisationHeading customSize="30px">
        Your personalized recommendations start here.
      </PersonalisationHeading>

      <p className="mb-16 text-body1 text-secondary">
        With your own personal AI treatment advisor, you&apos;ll have expert
        guidance anytime you need it.
      </p>

      <p className="text-body2 text-dark-grey">
        Get started in under a minute.
      </p>
    </PersonalisationScreenLayout>
  );
};
